import { type Row, record, upper } from './context.js';
import { CRIT_VARIANT_RULES } from '../authoring/campaign-house-rules';

/** The campaign house rules the browser damage pipeline reads.
 * The same rule ids and first-active-wins order the A2 attack lane resolves (websocket/attack-truth.ts). */
export type CritVariant = 'maximum' | 'rolled' | 'doubled';
export interface HouseRules {
  critVariant: CritVariant;
  explodingDice: boolean;
  remarkable: boolean;
  worldShaking: boolean;
  maimed: boolean;
  maimedOnDyingStratumFailBy5?: boolean;
  unhideMetaRolls?: boolean;
}

const EXPLODING_DICE_RULE = '6AE51489-5732-6F8B-3ACC-45B0B9118F3C';
const REMARKABLE_RULE = '6C85D904-D3AE-5680-666F-5FC49A4FFF4D';
const WORLD_SHAKING_RULE = '71221E94-E2E8-EF30-EE0E-8E4C53860250';
const MAIMED_RULE = 'FFFE4F7F-0018-4961-5BB9-2B69268CD48E';

/** A held campaign row → its active house rules. Null when no campaign row is held. */
export function campaignHouseRules(campaign: Row | null | undefined): HouseRules | null {
  const row = record(campaign);
  if (!row) return null;
  const rules = row.campaign_house_rules;
  const active = new Set((Array.isArray(rules) ? rules : []).map(rule => upper(record(rule)?.campaign_house_rule_id ?? rule)));
  return {
    critVariant: CRIT_VARIANT_RULES.find(([, id]) => active.has(id))?.[0] ?? 'maximum',
    explodingDice: active.has(EXPLODING_DICE_RULE),
    remarkable: active.has(REMARKABLE_RULE),
    worldShaking: active.has(WORLD_SHAKING_RULE),
    maimed: active.has(MAIMED_RULE),
    ...(active.has('0A0B2172-AF81-5D5B-188C-294D5DDB7B74') ? { maimedOnDyingStratumFailBy5: true } : {}),
    ...(active.has('03788F23-69EB-9DA7-1D4C-C07B93A33070') ? { unhideMetaRolls: true } : {}),
  };
}
